import { paraArray, type Vetor3 } from '../../dominio/geometria/vetor3'
import type { CorpoSolto } from '../../dominio/didatico/cargaSolta'
import { CORES_SEMANTICAS } from '../../dominio/didatico/tokens'

interface Props {
  corpo: CorpoSolto
  posicao: Vetor3
  /** versão fantasma, usada para a posição de origem antes do deslocamento livre */
  fantasma?: boolean
}

const COR_OBJETO = '#c9a86a'
const COR_ANIMAL = '#8a6a4a'

/**
 * Objeto ou animal solto, desenhado como volume procedural — a mesma decisão
 * de `VitimaProcedural`: o que importa é a proporção e a posição, não a malha.
 * Objeto vira uma caixa nas dimensões do catálogo; animal vira caixa + cápsula
 * (corpo + cabeça), o suficiente para o aluno reconhecer a silhueta.
 */
export function CorpoSoltoProcedural({ corpo, posicao, fantasma = false }: Props) {
  const cor = corpo.tipo === 'animal' ? COR_ANIMAL : COR_OBJETO
  const opacidade = fantasma ? 0.3 : 1

  return (
    <group position={paraArray(posicao)}>
      <mesh>
        <boxGeometry args={[corpo.dimensoes.x, corpo.dimensoes.y, corpo.dimensoes.z]} />
        <meshStandardMaterial
          color={fantasma ? '#7d8fa0' : cor}
          roughness={0.75}
          transparent={fantasma}
          opacity={opacidade}
        />
      </mesh>
      {corpo.tipo === 'animal' && (
        <mesh position={[0, corpo.dimensoes.y * 0.3, corpo.dimensoes.z / 2 + corpo.dimensoes.y * 0.22]}>
          <sphereGeometry args={[corpo.dimensoes.y * 0.32, 12, 10]} />
          <meshStandardMaterial
            color={fantasma ? '#7d8fa0' : cor}
            roughness={0.75}
            transparent={fantasma}
            opacity={opacidade}
          />
        </mesh>
      )}
      {!fantasma && (
        <mesh>
          <boxGeometry
            args={[corpo.dimensoes.x * 1.02, corpo.dimensoes.y * 1.02, corpo.dimensoes.z * 1.02]}
          />
          <meshBasicMaterial color={CORES_SEMANTICAS.rastro} wireframe transparent opacity={0.18} />
        </mesh>
      )}
    </group>
  )
}
